<template>
  <v-tooltip
    top
    color="secondary"
  >
    <template v-slot:activator="{ on: tooltip, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="{ ...tooltip }"
        color="accent"
        class="ma-2"
        @click="selectLogFile(logFileData)"
      >
        {{ title }}
      </v-btn>
    </template>
    <span>{{ logFileData.logpath + logFileData.logfile + '*' }}</span>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'LogDownloadButton',
    props: {
      logFileData: Object,
      title: String
    },
    data () {
      return {

      }
    },
    methods: {
      selectLogFile: function (data) {
        this.$emit('selectLogFile', data)
      }
    }
  }
</script>